module.exports = __webpack_public_path__ + "static/netcompany-service-3a91981c78c4ed6fcb1f233b84674f83.png";